export { RatingComponent } from './rating.component';
export { L_RatingModule } from './rating.module';



// WEBPACK FOOTER //
// ./.tmp/rating/index.ts